<div [ngClass]="'kt-' + this.type" [ngStyle]="{'background-image': 'url('+image+')'}" class="kt-grid__item kt-grid__item--fluid kt-grid">

	<ng-container *ngIf="type === 'error-v1'">
		<div class="kt-error-v1__container" [ngClass]="{'kt-error_container-no-errors': descriptionErrors && descriptionErrors.length > 1}">
			<h1 class="kt-error-v1__number">{{code}}</h1>
			<p class="kt-error-v1__desc" [innerHTML]="desc" *ngIf="!descriptionErrors || descriptionErrors.length === 0"></p>
			<div class="d-flex" *ngIf="descriptionErrors && descriptionErrors.length > 0">
				<h2 class="kt-error_subtitle2">Details: </h2>
				<ul>
					<li class="kt-error_description" *ngFor="let error of descriptionErrors">{{ error }}</li>
				</ul>
			</div>
			<div class="d-flex" *ngIf="webService && webService !== ''">
				<h2 class="kt-error_subtitle2">Web service: </h2>
				<p class="kt-error_description">{{ webService }}</p>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="type === 'error-v2'">
		<div class="kt-error_container" [ngClass]="{'kt-error_container-no-errors': descriptionErrors && descriptionErrors.length > 1}">
			<div class="kt-error_title2 kt-font-light">
				<h1>{{title}}</h1>
			</div>
			<span class="kt-error_desc kt-font-light" [innerHTML]="desc" *ngIf="!descriptionErrors || descriptionErrors.length === 0"></span>
			<div class="d-flex" *ngIf="descriptionErrors && descriptionErrors.length > 0">
				<h2 class="kt-error_subtitle2">Details: </h2>
				<ul>
					<li class="kt-error_description" *ngFor="let error of descriptionErrors">{{ error }}</li>
				</ul>
			</div>
			<div class="d-flex" *ngIf="webService && webService !== ''">
				<h2 class="kt-error_subtitle2">Web service: </h2>
				<p class="kt-error_description">{{ webService }}</p>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="type === 'error-v3'">
		<div class="kt-error_container" [ngClass]="{'kt-error_container-no-errors': descriptionErrors && descriptionErrors.length > 1}">
			<p class="kt-error_title" [innerHTML]="title"></p>
			<p class="kt-error_subtitle" [innerHTML]="subtitle"></p>
            <p class="kt-error_description" [innerHTML]="desc" *ngIf="!descriptionErrors || descriptionErrors.length === 0"></p>
			<div class="d-flex" *ngIf="descriptionErrors && descriptionErrors.length > 0">
				<h2 class="kt-error_subtitle2">Details: </h2>
				<ul>
					<li class="kt-error_description" *ngFor="let error of descriptionErrors">{{ error }}</li>
				</ul>
			</div>
			<div class="d-flex" *ngIf="webService && webService !== ''">
				<h2 class="kt-error_subtitle2">Web service: </h2>
				<p class="kt-error_description">{{ webService }}</p>
			</div>
			<ng-container *ngIf="code && code !== 403">
				<p>
                    <button mat-raised-button (click)="goHome()" >{{return}}</button>
                    <!-- <button mat-button color="warn" (click)="sendEmail()">Send Error</button> -->
					<button mat-raised-button color="warn" (click)="sendEmail()" [ngClass]="{'kt-spinner kt-spinner--center kt-spinner--md kt-spinner--light': loader}">
						&nbsp;
						<ng-container *ngIf="!loader">
							Send Error to IT
						</ng-container>
						&nbsp;
					</button>

					<button mat-raised-button color="warn" (click)="clearCache()" >
						&nbsp;
						<ng-container >
							Clear Cache
						</ng-container>
						&nbsp;
					</button>
                </p>
			</ng-container>
            <ng-container *ngIf="code && code === 403">
                <p>
                    <button mat-raised-button [routerLink]="[ '/' ]" >{{return}}</button>
                    <button mat-raised-button color="warn" (click)="logout()">Sign Out</button>
                </p>
            </ng-container>
		</div>
	</ng-container>

	<ng-container *ngIf="type === 'error-v4'">
		<div class="kt-error_container" [ngClass]="{'kt-error_container-no-errors': descriptionErrors && descriptionErrors.length > 1}">
			<h1 class="kt-error_number">
				{{code}}
			</h1>
			<p class="kt-error_title">
				{{title}}
			</p>
			<p class="kt-error_subtitle">
				{{subtitle}}
			</p>
			<p class="kt-error_description" [innerHTML]="desc" *ngIf="!descriptionErrors || descriptionErrors.length === 0"></p>
			<div class="d-flex" *ngIf="descriptionErrors && descriptionErrors.length > 0">
				<h2 class="kt-error_subtitle2">Details: </h2>
				<ul>
					<li class="kt-error_description" *ngFor="let error of descriptionErrors">{{ error }}</li>
				</ul>
			</div>
			<div class="d-flex" *ngIf="webService && webService !== ''">
				<h2 class="kt-error_subtitle2">Web service: </h2>
				<p class="kt-error_description">{{ webService }}</p>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="type === 'error-v5'">
		<div class="kt-error_container" [ngClass]="{'kt-error_container-no-errors': descriptionErrors && descriptionErrors.length > 1}">
			<div class="kt-error_title">
				<h1>{{title}}</h1>
			</div>
			<p class="kt-error_subtitle">{{subtitle}}</p>
			<p class="kt-error_description" [innerHTML]="desc" *ngIf="!descriptionErrors || descriptionErrors.length === 0"></p>
			<div class="d-flex" *ngIf="descriptionErrors && descriptionErrors.length > 0">
				<h2 class="kt-error_subtitle2">Details: </h2>
				<ul>
					<li class="kt-error_description" *ngFor="let error of descriptionErrors">{{ error }}</li>
				</ul>
			</div>
			<div class="d-flex" *ngIf="webService && webService !== ''">
				<h2 class="kt-error_subtitle2">Web service: </h2>
				<p class="kt-error_description">{{ webService }}</p>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="type === 'error-v6'">
		<div class="kt-error_container" [ngClass]="{'kt-error_container-no-errors': descriptionErrors && descriptionErrors.length > 1}">
			<div class="kt-error_subtitle kt-font-light">
				<h1>{{title}}</h1>
			</div>
			<p class="kt-error_description kt-font-light" [innerHTML]="desc" *ngIf="!descriptionErrors || descriptionErrors.length === 0"></p>
			<div class="d-flex" *ngIf="descriptionErrors && descriptionErrors.length > 0">
				<h2 class="kt-error_subtitle2">Details: </h2>
				<ul>
					<li class="kt-error_description" *ngFor="let error of descriptionErrors">{{ error }}</li>
				</ul>
			</div>
			<div class="d-flex" *ngIf="webService && webService !== ''">
				<h2 class="kt-error_subtitle2">Web service: </h2>
				<p class="kt-error_description">{{ webService }}</p>
			</div>
		</div>
	</ng-container>

</div>
